import { BaseModel } from "./BaseModel"
import { CompanyResource } from "~/api"

export class EntrepriseModel extends BaseModel<CompanyResource> {
    static primaryKey = "id"
}

export interface EntrepriseModel extends CompanyResource {}
